<template lang="pug">
  div
    template(v-if="hasCash || hasShares")
      .asset--chart-container
        .asset--chart(v-if="chart_data != null")
          DoughnutChart(:chart-data='chart_data', :options="chart_options")

    template(v-else)
      MessageBar(type="warning") You have no assets currently

</template>



<script>
  import DoughnutChart from '@/components/charts/Doughnut';
  import MessageBar from '@/components/MessageBar';
  import allFilters from '@/lib/filters';

  const graphSkeleton = [
    {
      id: 'LOCAL_CASH',
      legend: 'Local Cash',
      backgroundColor: '#3498db',
      total: 0,
    },
    {
      id: 'FOREIGN_CASH',
      legend: 'Foreign Cash',
      backgroundColor: '#1abc9c',
      total: 0,
    },
    {
      id: 'EQUITY',
      legend: 'Equity',
      backgroundColor: '#e67e22',
      total: 0,
    },
  ]

  export default {
    props: {
      cash: {
        type: Array,
        required: true
      },
      shares: {
        type: Array,
        required: true
      },
    },


    components: {
      DoughnutChart,
      MessageBar
    },


    data: () => ({
      chart_data: null,
      chart_options: {
        responsive: true,
        cutoutPercentage: 70, 
        legend: {
          position: 'top',
          labels: {
            boxWidth: 12,
          }
        }
      },
    }),


    computed: {
      hasCash() {
        return this.cash.length > 0;
      },
      hasShares() {
        return this.shares.length > 0;
      }
    },


    methods: {
      DRAW_SUMMARY_CHART() {
        let chartData = this.CALCULATE_CHART_DATA();

        let output = {
          labels: [],
          datasets: [{
            backgroundColor: [],
            data: [],
          }],
        };

        chartData.forEach(item => {
          let { legend, backgroundColor, total } = item;
          output.labels.push(legend);
          output.datasets[0].backgroundColor.push(backgroundColor)
          output.datasets[0].data.push(total);
        });

        this.chart_data = output;
      },

      CALCULATE_CHART_DATA() {
        // TODO: Not sure how the data is structured from the API
        // Current assumption is that there's only 4 type of assets
        // Local cash (MYR), Foreign Cash (Anything But)
        // Local Shares (MYR), Foreign Shares (Anything But)
        // currently, the cash is segmented by 'currency' key, 'MYR' - local, anything but is foreign
        // currently, no way for me to tell equities local or foreign
        let data = JSON.parse(JSON.stringify(graphSkeleton));

        // Get total of cash (local + foreign)
        this.cash.forEach(account => {
          account.currencyTrustBalanceDtos.forEach(r => {
            let { currency, myrBalance } = r;
            let isLocal = currency === 'MYR';
            let propId = isLocal ? 'LOCAL_CASH' : 'FOREIGN_CASH';
            let index = data.findIndex(item => item.id === propId);
            data[index].total += myrBalance;
          })
        });

        // Get total of shares
        this.shares.forEach(account => {
          let { cdsMarketValue } = account;
          let index = data.findIndex(item => item.id === 'EQUITY');
          data[index].total += cdsMarketValue;
        })

        return data;
      }
    },


    mounted() {
      this.DRAW_SUMMARY_CHART();
    }
  }
</script>



<style lang="scss">
  .asset--chart-container {
    margin: 0 auto;
    max-width: 270px;

    @include MQ(XL) {
    }
    @include MQ(LG) {
    }
    @include MQ(MD) {
      margin: 0;
    }
    @include MQ(SM) {
    }
    @include MQ(XSM) {
      max-width: 300px;
    }
    @include MQ(XS) {
      margin: 0 auto;
      max-width: 270px;
    }
  }
</style>